"use client";

import { LoaderCircleIcon } from "lucide-react";
import { Suspense } from "react";

import BookingFlow from "./booking-flow";

// Book page — renders the 2-tab booking flow (By Instructor / By Class Type)
export default function BookPage() {
  return (
    <Suspense
      fallback={
        <div className="flex flex-col items-center justify-center min-h-screen gap-4">
          <LoaderCircleIcon className="h-8 w-8 animate-spin text-muted-foreground" />
          <p className="text-sm text-muted-foreground">Loading booking options...</p>
        </div>
      }
    >
      <BookingFlow />
    </Suspense>
  );
}
